import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=383df54e&scoped=true"
import script from "../js/Auth/forgetPassword.js?vue&type=script&lang=js&external"
export * from "../js/Auth/forgetPassword.js?vue&type=script&lang=js&external"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=383df54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383df54e",
  null
  
)

export default component.exports